const mainProjects = [
  {
    id: 10,
    title: "SoulCaller",
    image: "https://i.ibb.co/4wp7fKT4/Sk-rmavbild-2025-04-29-kl-15-20-07.png",
    netlify: null,
    heading: "A COMMUNITY DRIVEN CARD GAME",
    description:
      "A digital card game where players design their own cards through a balanced point-based system. The project combines game design, AI-generated artwork, cloud infrastructure and custom content creation tools to enable creative freedom while maintaining gameplay balance.",
    github: null,
    tools: [
      "Google Cloud",
      "Cloud Infrastructure",
      "API Integration",
      "Database Design",
      "Access Management",
      "AI-generated Content",
    ],
  },
  {
    id: 11,
    title: "Family Information Display",
    image:
      "https://i.ibb.co/tPHmLFNh/Chat-GPT-Image-Jun-1-2026-02-14-04-PM.png",
    netlify: null,
    heading: "A SHARED FAMILY DASHBOARD",
    description:
      "An information display that brings together multiple Google Calendars into a single shared view. Built to give the whole family a clear overview of upcoming activities, appointments and events. The project combines API integrations, information design and usability to solve a real everyday problem.",
    github: null,
    tools: [
      "Google Calendar API",
      "Information Design",
      "Multi-source Data",
      "Dashboard",
      "UX Design",
    ],
  },
  {
    id: 12,
    title: "Cybersecurity Learning Quest",
    image: "https://i.ibb.co/DHQVzhB3/Screenshot-2026-05-31-234335.png",
    netlify: null,
    heading: "A GAMIFIED KNOWLEDGE JOURNEY",
    description:
      "An experimental project exploring how visual progression, milestones and gamification can be used to structure and explore cybersecurity and privacy concepts.",
    github: null,
    tools: [
      "Cybersecurity",
      "Gamification",
      "Information Design",
      "UX Design",
      "Privacy",
    ],
  },
  {
    id: 1,
    title: "Todo App",
    image: "https://i.ibb.co/ng7j1Dk/todo.png",
    netlify: "https://todomedi.netlify.app/",
    heading: "Todo App",
    description: "A simple task manager with sorting and delete functionality.",
    github: "https://github.com/silvertejp89/TodoMedi",
    tools: ["Javascript"],
  },
  {
    id: 2,
    title: "Emojipedia",
    image: "https://i.ibb.co/h1K0xGt/emojipedia.png",
    netlify: "https://kriss-emojipedia.netlify.app",
    heading: "MAPPING EMOJIS",
    description:
      "A small exercise focusing on mapping components in react, creating a site that explain the meanings of some emojis.",
    github: "https://github.com/silvertejp89/emojipedia",
    tools: ["React", "Props", "Reusable Components", "Github", "Responsive"],
  },
  {
    id: 3,
    title: "Get Time",
    image: "https://i.ibb.co/LtmXNKG/getTime3.png",
    netlify: "https://kriss-real-time-clock.netlify.app/",
    heading: "A LITTLE CLOCK EXERCISE",
    description:
      "A tiny app that fetches the latest time and automatically updates it every second. A good repetition of the useState-hook and destructuring arrays.",
    github: "https://github.com/silvertejp89/project-real-time-clock",
    tools: ["React", "React Hooks", "Javascript", "Arrays", "Github"],
  },
  {
    id: 4,
    title: "Givers Game",
    image: "https://i.ibb.co/ZYjf29h/giversgame-07.png",
    netlify: "https://giversgame.netlify.app/",
    heading: "A TODO-APP WITH COMPASSION (under reconstruction)",
    description:
      "An application that makes it easier to get help or help others with for example everyday tasks. Givers game is a todo-app that makes it possible to list tasks and distribute responsibilities. You create groups and invite members that wants to contribute.",
    github: "https://github.com/Mattsson717/kriss-patrik-final",
    tools: [
      "React",
      "Redux",
      "Node",
      "Mongoose",
      "MongoDB",
      "Pair-programming",
    ],
  },
  {
    id: 5,
    title: "Movies",
    image: "https://i.ibb.co/XtfBYm0/willy-Wonka.png",
    netlify: "https://movie-project-kriss-a1eksa.netlify.app/",
    heading: "A SITE ABOUT MOVIES",
    description:
      "Our movie site, a multi-page application fetching and displaying movies and details from an API.",
    github:
      "https://github.com/silvertejp89/project-movies/tree/master/code/src",
    tools: ["React", "API", "React Hooks", "React Router", "Pair-programming"],
  },
  {
    id: 6,
    title: "Happy Thoughts",
    image: "https://i.ibb.co/jJ9pk5d/Happy-Thoughts.png",
    netlify: "https://kriss-happy-thoughts.netlify.app/",
    heading: "POST HAPPY THOUGHTS TO AN API (under reconstruction)",
    description:
      "My own positive version of twitter, built with HTML, CSS and connected to a database that I created.",
    github: "https://github.com/silvertejp89/project-happy-thoughts",
    tools: ["HTML5", "CSS", "JavaScript", "React", "API", "MongoDB"],
  },
  {
    id: 7,
    title: "Labyrinth",
    image: "https://i.ibb.co/n6cmXZQ/Labyrinth.png",
    netlify: "https://theevenmoreabsolutebestfoxes.netlify.app/",
    heading: "LABYRINTH API (under reconstruction)",
    description:
      "Navigate a maze, in the form of a text-based adventure, provided by a backend",
    github: "https://github.com/silvertejp89/project-labyrinth",
    tools: [
      "API",
      "Redux",
      "Reusable Components",
      "JavaScript",
      "Pair-programming",
    ],
  },
  {
    id: 8,
    title: "To Do",
    image: "https://i.ibb.co/jJ0rs6z/Todos.png",
    netlify: "https://kriss-todo.netlify.app/",
    heading: "TODO APP",
    description:
      "A todo-application made with React Redux, were the user can list tasks and toggle whether a task is done or not.",
    github: "https://github.com/silvertejp89/project-todos",
    tools: ["React", "Redux-toolkit", "CSS"],
  },
  {
    id: 9,
    title: "Quiz",
    image: "https://i.ibb.co/xgYhYHV/Quiz.png",
    netlify: "https://common-knowledge.netlify.app/",
    heading: "QUIZ ABOUT RANDOM FACTS",
    description:
      "A multiple choice quiz about whacky facts, created with React Redux and mob-programming.",
    github: "https://github.com/silvertejp89/Redux-Quiz",
    tools: ["React", "Redux", "React Hooks", "Mob-programming"],
  },
];

export default mainProjects;
